import { SvgProps } from './ic_portfolio';

export function IconEarn(props: SvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={28} {...props}>
      <g clipPath="">
        <path d="M23.75 7.875h-3.837c.043-.036.087-.071.128-.11a3.23 3.23 0 0 0 1.084-2.343 3.567 3.567 0 0 0-3.67-3.672 3.23 3.23 0 0 0-2.346 1.084 6.007 6.007 0 0 0-.984 1.584 6.007 6.007 0 0 0-.984-1.584 3.23 3.23 0 0 0-2.345-1.084 3.568 3.568 0 0 0-3.671 3.672 3.23 3.23 0 0 0 1.084 2.344c.041.036.085.07.128.11H4.5a1.75 1.75 0 0 0-1.75 1.75v3.5a1.75 1.75 0 0 0 1.75 1.75v7a1.75 1.75 0 0 0 1.75 1.75h6.563a.438.438 0 0 0 .437-.438V13.125H4.5v-3.5h8.75v3.5H15v-3.5h8.75v3.5H15v10.063a.437.437 0 0 0 .438.437H22a1.75 1.75 0 0 0 1.75-1.75v-7a1.75 1.75 0 0 0 1.75-1.75v-3.5a1.75 1.75 0 0 0-1.75-1.75ZM9.368 6.453a1.497 1.497 0 0 1-.492-1.094A1.818 1.818 0 0 1 10.69 3.5h.053a1.497 1.497 0 0 1 1.094.492c.918 1.037 1.241 2.756 1.355 3.82-1.068-.113-2.786-.437-3.824-1.359Zm9.516 0c-1.038.919-2.76 1.243-3.828 1.356.13-1.15.49-2.832 1.366-3.816a1.497 1.497 0 0 1 1.094-.492h.053a1.818 1.818 0 0 1 1.806 1.867 1.499 1.499 0 0 1-.493 1.085h.002Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.125 0h28v28h-28z" />
        </clipPath>
      </defs>
    </svg>
  );
}
